import { render, staticRenderFns } from "./DeptAdd.vue?vue&type=template&id=dcef2c96"
import script from "./DeptAdd.vue?vue&type=script&lang=js"
export * from "./DeptAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports